module.exports = __webpack_public_path__ + "static/media/AboutNiaText.d727c41e.png";